import { eHierarchyLevel } from "functions/api/enums";
import { isArsMasterReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { applyVariantPatches } from "functions/tlf/applyVariantPatches";
import { groupVariantPatches } from "functions/tlf/groupVariantPatches";
import { pickVariantUpdateable } from "functions/tlf/pickVariantUpdateable";
import { checkChanged } from "./checkChanged";
import { ITlfActionApplyVariantTemplate, TlfContextProps } from "./interface";
import { toArsTlfSnapshot } from "./toArsTlfSnapshot";
import { updateVariantPatchSelection } from "./updateVariantPatchSelection";

/**
 * Replaces the applied selection and retains its master baseline without editing stored patches.
 *
 * @param state - Current TLF, patch catalogue and master baseline
 * @param action - Complete patch selection to compose from the master
 * @returns Updated unsaved TLF, or unchanged state for an invalid selection
 */
export const tlf_applyVariantTemplate = (
  state: TlfContextProps,
  action: ITlfActionApplyVariantTemplate,
): TlfContextProps => {
  if (state.readOnly || !isArsMasterReadDto(state.tlfData)) return state;
  const current = state.tlfData;
  const patchNames = action.patchNames;
  if (
    state.activeVariantPatchInvalidOps.length > 0 ||
    patchNames.some((name) => !Object.hasOwn(current.allVariantPatches, name)) ||
    groupVariantPatches(current).some(
      (group) => group.filter((name) => patchNames.includes(name)).length > 1,
    )
  )
    return state;
  const master =
    current.primaryHierarchyLevel === eHierarchyLevel.Report ||
    state.appliedVariantPatches.length > 0
      ? state.masterTlfData
      : toArsTlfSnapshot(current);
  if (master === null) return state;
  const composed = applyVariantPatches(master, current, patchNames);
  if (!composed.success) return state;
  const updated = updateVariantPatchSelection(
    {
      ...state,
      tlfData: { ...current, ...pickVariantUpdateable(composed.data) },
      masterTlfData: master,
      variantCreationView: false,
      activeVariantPatchInvalidOps: [],
    },
    patchNames,
    null,
  );
  checkChanged(updated);
  return updated;
};
